import React, { lazy, useState } from 'react';
import PropTypes from 'prop-types';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import { ROLES } from 'globalconfig/constants/keys';
import { driverStatusColumns, getELDStatusIcon } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const Modal = lazy(() => import(`globalcomponents/UI/Modal/${layout}`));
const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));

const DriverStatus = ({ driverStatus, i18n, columns, generateRow, history }) => {
  const [modal, setModal] = useState(false);
  const defaultColumns = columns || driverStatusColumns;

  const generateRows = () => {
    const updatedList = driverStatus?.map((item) => {
      const row = {};
      for (let i = 0; i < item.infoWithLink.length; i++) {
        const rowItem = item.infoWithLink[i];
        if (checkServiceProvider('driverStatus_generateRows', window.$environment.SERVICE_PROVIDER, false)) {
          if (i === 0) {
            row[defaultColumns[0].id] = rowItem.link ? (
              <Link
                href={
                  window.location.origin +
                  rowItem.link
                    .replace('.', window.$environment.CURRENT_LAYOUT === 'SpireonOld' ? '' : '/spireon')
                    .replace('edit', hasRestrictedRole([ROLES.VIEW_ONLY_FM]) ? 'view' : 'edit')
                }
              >
                {rowItem.item}
              </Link>
            ) : (
              rowItem.item
            );
          } else if (i === item.infoWithLink.length - 1) {
            row[defaultColumns[i].id] =
              window.$environment.CURRENT_LAYOUT === 'SpireonOld' ? (
                <div className={getELDStatusIcon(rowItem.item)} />
              ) : (
                <a
                  onClick={() => {
                    if (rowItem.link) {
                      history.push(rowItem.link.replace('.', '/spireon'));
                    } else {
                      setModal(true);
                    }
                  }}
                >
                  <div className={getELDStatusIcon(rowItem.item)} />
                </a>
              );
          } else {
            row[defaultColumns[i].id] = rowItem.item;
          }
        } else {
          row[defaultColumns[i].id] = rowItem.link ? (
            <Link href={window.location.origin + rowItem.link.replace('.', '')} newPage>
              {rowItem.item}
            </Link>
          ) : (
            rowItem.item
          );
        }
      }

      return row;
    });
    return updatedList;
  };

  return (
    <>
      <Modal
        open={modal}
        setOpen={() => setModal((m) => !m)}
        withCloseIcon
        alignItemsLeft
        noDataPopup
        data={{
          header: '',
          content: () => <div>No Logs available</div>,
        }}
      />
      <Table
        type="client"
        title=""
        columns={[...defaultColumns]}
        data={generateRow ? generateRow() : generateRows()}
        emptyMessage={i18n.t('common.tableEmptyMessage')}
        itemsPerPage={10}
        actions={[]}
        i18n={i18n}
        noPagination
      />
    </>
  );
};

export default DriverStatus;

DriverStatus.defaultProps = {};

DriverStatus.propTypes = {
  driverStatus: PropTypes.array.isRequired,
};
